class HomeController {
  constructor($window, $state) {
    'ngInject';
    // directly go to news panel if not xs screen
    if ($window.innerWidth >= 768) {
      $state.go('news');
    }
  }
}

export default HomeController;



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js